import { useInView } from "motion/react";
import {
  useEffect,
  useRef,
  type DetailedHTMLProps,
  type HTMLAttributes,
  type PropsWithChildren,
  type RefObject,
} from "react";

export function ViewDetector({
  children,
  once = false,
  disabled = false,
  root,
  onEnterView,
  ...props
}: PropsWithChildren<{
  disabled?: boolean;
  onEnterView: () => void;
  once?: boolean;
  root?: RefObject<Element | null>;
}> &
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  const element = useRef<HTMLDivElement>(null);
  const inView = useInView(element, { root, once });
  useEffect(() => {
    if (inView && !disabled) onEnterView?.();
  }, [inView, disabled, onEnterView]);
  return (
    <div ref={element} {...props}>
      {children}
    </div>
  );
}
